import { useState } from "react";
import "./FollowUpQuestions.css";

const FollowUpQuestions = ({ questions, onQuestionClick }) => {
    const [pendingIndex, setPendingIndex] = useState(null);

    if (!Array.isArray(questions) || questions.length === 0) return null;

    const handleClick = async (question, index) => {
        if (pendingIndex !== null) return;
        setPendingIndex(index);
        try {
            await onQuestionClick(question);
        } finally {
            setPendingIndex(null);
        }
    };

    return (
        <div className="followups-card">
            <div className="followups-header">Suggested follow-ups</div>
            <ul className="followups-list">
                {questions.map((question, index) => (
                    <li
                        key={index}
                        className={`followups-item${pendingIndex === index ? " followups-item-pending" : ""}`}
                        onClick={() => handleClick(question, index)}
                    >
                        {question}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FollowUpQuestions;
